import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\Repos\\cinema-drip-website\\src\\app\\(Pages)\\Blogs\\page.jsx")